import * as yup from 'yup';

import { CompanySuggestItem } from 'services/SwaggerApi';

export const schema = yup.object({
    company: yup.mixed<CompanySuggestItem>()
        .nullable()
        .required(),
});
